import { useTranslation } from 'react-i18next'
import { LANGUAGES } from '../i18n'

export default function LanguageSwitch({ className = '' }) {
  const { t, i18n } = useTranslation()
  return (
    <div role="group" aria-label={t('nav.language')} className={`flex rounded-full bg-surface/70 p-1 ${className}`}>
      {LANGUAGES.map((l) => {
        const active = i18n.resolvedLanguage === l.code
        return (
          <button
            key={l.code}
            type="button"
            lang={l.code}
            aria-pressed={active}
            onClick={() => i18n.changeLanguage(l.code)}
            className={`min-w-9 cursor-pointer rounded-full px-2.5 py-1.5 text-sm font-extrabold transition ${
              active ? 'bg-ink text-on-ink' : 'text-subtle hover:text-ink'
            }`}
          >
            {l.label}
          </button>
        )
      })}
    </div>
  )
}
